import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { displayField, isNotEmpty } from "../../../utils/helpers";

const AddressCell = ({
  rowData,
  positionFromRight = "26.5",
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("ADDRESS")}>
      <p>
        <b>{t("HOUSE_NO")}:</b> {displayField(rowData.house_no)}
      </p>
      <p>
        <b>{t("BUILDING")} :</b> {displayField(rowData.building_name)}
      </p>
      <p>
        <b>{t("AREA")} :</b> {displayField(rowData.area_name)}
      </p>
      <p>
        <b>{t("LANDMARK")}:</b> {displayField(rowData.landmark)}
      </p>
      <p>
        <b>{t("PINCODE")}:</b> {displayField(rowData.pincode)}
      </p>
      <p>
        <b>{t("CITY")} :</b> {displayField(rowData.city_name)}
      </p>
      <p>
        <b>{t("STATE")} :</b> {displayField(rowData.state_name)}
      </p>
      <p>
        <b>{t("COUNTRY")} :</b> {displayField(rowData.country_name)}
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="left"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>
          {isNotEmpty(`${rowData.area_name}`) && `${rowData.area_name},`}{" "}
          {displayField(rowData.city_name)}
        </a>
      </Whisper>
    </Cell>
  );
};

export default AddressCell;
